import { ContactForm } from "../../components/landing/ContactForm";

export const ContactPage = () => {  // ou 'export function ContactPage()'
    return (
        <div className="flex items-center justify-center bg-gradient-to-br from-gray-100 to-gray-300 dark:from-gray-900 dark:to-black py-12 px-4 sm:px-6 lg:px-8 pt-24">
        {/* pt-24 ajouté pour compenser la hauteur du header */}
        <ContactForm />
      </div>
    );
  };